import React, { Component } from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import Session from './helpers/session';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'sweetalert2/src/sweetalert2.scss'
import './App.scss';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;
const DefaultLayout = React.lazy(() => import('./Layout/Layout'));
const Login = React.lazy(() => import('./Containers/Login'));
const Terms = React.lazy(() => import('./Containers/terms'));
const Policy = React.lazy(() => import('./Containers/policy'));

class App extends Component {

  render() {

    return (
      <HashRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route
                exact
                path="/login"
                name="Login"
                render={props => {
                  if (Session.shared().loguedIn) {
                    return <Redirect to="/coaches" />;
                  }
                  return <Login {...props}/>;
                }}
              />
              <Route
                exact
                path="/terminos-y-condiciones"
                name="Terminos y condiciones"
                render={() => <Terms />}
              />
              <Route
                exact
                path="/politicas-de-privacidad"
                name="Politicas de privacidad"
                render={() => <Policy />}
              />
              <Route
                path="/"
                name="Inicio"
                render={props => {
                  if (!Session.shared().loguedIn) {
                      return <Redirect to="/login" />
                  }
                  return <DefaultLayout {...props}/>
                }}
              />
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
